module.exports = __webpack_public_path__ + "media/images/flags/4x3/jey-937a06a7f102cb5c70b67b7c0eb9bb51.svg";